import { BusMessage, calcStringByteLength, MessageFactory } from "flavr-common";
/**
 * Carries data for an offscreen rendering surface.
 */
export class OffscreenMessage extends BusMessage {
    get byteLength() {
        return OffscreenMessage.BYTE_LENGTH;
    }
    constructor(id, rendererType, offscreen, width, height, pixelRatio) {
        super();
        this.id = id;
        this.rendererType = rendererType;
        this.offscreen = offscreen;
        this.width = width;
        this.height = height;
        this.pixelRatio = pixelRatio;
    }
    serialization() { }
    static is(msg) {
        return msg.type === OffscreenMessage.typestatic;
    }
}
OffscreenMessage.typestatic = "OffscreenMessage";
OffscreenMessage.subjectstatic = "local";
OffscreenMessage.BYTE_LENGTH = 0;
MessageFactory.register(OffscreenMessage);
/**
 * Requests destruction of an offscreen rendering surface.
 */
export class DestroyOffscreenMessage extends BusMessage {
    get byteLength() {
        return calcStringByteLength(this.id);
    }
    constructor(id) {
        super();
        this.id = id;
    }
    serialization(stream) {
        this.id = stream.utf16String(this.id);
    }
    static is(msg) {
        return msg.type === DestroyOffscreenMessage.typestatic;
    }
}
DestroyOffscreenMessage.typestatic = "DestroyOffscreenMessage";
DestroyOffscreenMessage.subjectstatic = "general";
MessageFactory.register(DestroyOffscreenMessage);
/**
 * Announces that an offscreen texture needs an update.
 */
export class OffscreenTextureNeedsUpdateMessage extends BusMessage {
    get byteLength() {
        return calcStringByteLength(this.id);
    }
    constructor(id) {
        super();
        this.id = id;
    }
    serialization(stream) {
        this.id = stream.utf16String(this.id);
    }
    static is(msg) {
        return msg.type === OffscreenTextureNeedsUpdateMessage.typestatic;
    }
}
OffscreenTextureNeedsUpdateMessage.typestatic = "OffscreenTextureNeedsUpdateMessage";
OffscreenTextureNeedsUpdateMessage.subjectstatic = "general";
MessageFactory.register(OffscreenTextureNeedsUpdateMessage);
